import React from 'react';
import { CyberAssociation2026 } from '../views';

const ClassAssembly11CPage = () => {
    return <CyberAssociation2026/>;
  };
  
export default ClassAssembly11CPage;
